/**
 * When NEXT_PUBLIC_ALTERNATE_SIGN_UP_URL is non-empty, sign-up flows show a
 * single CTA button to that URL instead of the sign-up / registration form.
 */
export const alternateSignUpUrl =
  process.env.NEXT_PUBLIC_ALTERNATE_SIGN_UP_URL?.trim() ?? '';

export const alternateSignUpButtonLabel =
  process.env.NEXT_PUBLIC_ALTERNATE_SIGN_UP_BUTTON_LABEL?.trim() ||
  'Apply on soona';

export const isAlternateSignUpEnabled = alternateSignUpUrl.length > 0;
